import { PageContainer } from '~/components/elements/PageContainer/PageContainer';
import { Button } from '@ubie/ubie-ui';
import styles from './style.module.css';
import { useRouter } from 'next/router';
import React, { useCallback } from 'react';

type Props = {
  resetErrorBoundary?: () => void;
};
export const ErrorRetryable: React.FC<Props> = ({ resetErrorBoundary }) => {
  const router = useRouter();

  const onClickReload = useCallback(() => {
    if (resetErrorBoundary != null) {
      resetErrorBoundary();
    } else {
      router.reload();
    }
  }, [router, resetErrorBoundary]);

  return (
    <PageContainer title="ネットワークへの接続が不安定になっています" hideHeader>
      <div className={styles.message}>
        インターネット環境をご確認のうえ、再度お試しください。問題が解決しない場合は、しばらく時間をおいてから再度アクセスしてください
      </div>
      <div className={styles.reloadButtonArea}>
        <Button onClick={onClickReload}>リロード</Button>
      </div>
    </PageContainer>
  );
};
